export const PAGE_ONBOARDING = 'onboarding'
export const PAGE_DASHBOARD = 'dashboard'
export const PAGE_ORDERS = 'orders'
export const PAGE_BILLING = 'billing'
export const PAGE_SHIPMENT_TRACKER = 'shipment-tracker'
export const PAGE_E_INVOICES = 'e-invoices'
export const PAGE_REPORTS = 'reports'
